<template>
  <custom-modal
    class="custom-modal__extended"
    id="create-request-modal-confirm"
    ref="createRequestModalConfirmRef"
    v-b-modal.modal-center
    :title="$t('TermsConditionsTitle')"
    @accept="() => {}"
  >
    <div class="py-2 px-2 font-14 text-left color-black">
      <div
        v-if="this.userSelectedLang === this.lang.ES"
        class="text-container px-4"
      >
        <p>
          1- El solicitante releva al Departamento de Educación de Puerto Rico
          de toda responsabilidad por cualquier reclamación que pueda surgir
          como consecuencia de las actividades del estudio y de la información
          que se solicite y provea por medio de este. El Departamento de
          Educación de Puerto Rico no se hace responsable de cualquier daño y
          perjuicio o reclamación producto del proceso de realización, o del
          resultado de la investigación; se releva, así, de cualquier obligación
          y responsabilidad al Departamento de Educación de Puerto Rico, sus
          empleados y funcionarios en cualquier reclamación, pleito o demanda
          que se presente relacionada, directa o indirectamente a esta
          investigación. La misma es una independiente no auspiciada por el
          Departamento de Educación de Puerto Rico. El Departamento de Educación
          de Puerto Rico no se solidariza necesariamente con los resultados de
          la investigación.
        </p>
        <p>
          2- La solicitud de autorización deberá radicarse con los documentos
          requeridos seis (6) semanas antes de la fecha en que se iniciará la
          investigación o algunas de sus fases relacionadas: la validación de
          los instrumentos o la prueba piloto.
        </p>
        <p>
          3- El periodo de vigencia de la autorización otorgada para la
          validación o prueba piloto será de seis (6) meses y para la
          investigación (fase final) será de doce (12) meses de duración a
          partir de la fecha de expedición del memorando de autorización.
        </p>
        <p>
          4- Si el investigador necesita tiempo adicional para completar las
          actividades del estudio, deberá solicitar por escrito una extensión de
          tiempo a la oficina que le expidió la autorización: la División de
          Investigaciones Pedagógicas (SATPRe) o a la oficina del
          Superintendente Regional en el ORE) correspondiente, antes que
          finalice la vigencia de la autorización otorgada.
        </p>
        <p>
          5- Todos los documentos sometidos deberán incluir la siguiente
          cláusula de relevo de responsabilidad del Departamento de Educación de
          Puerto Rico: “Se releva al Departamento de Educación de Puerto Rico de
          toda responsabilidad por cualquier reclamación que pueda surgir como
          consecuencia de las actividades del estudio y de la información que se
          solicite y provea por medio de este. El Departamento de Educación de
          Puerto Rico no se hace responsable de cualquier daño y perjuicio o
          reclamación producto del proceso de realización, o del resultado de la
          investigación; se releva, así, de cualquier obligación y
          responsabilidad al Departamento de Educación de Puerto Rico, sus
          empleados y funcionarios en cualquier reclamación, pleito o demanda
          que se presente relacionada, directa o indirectamente a esta
          investigación. La misma es una independiente no auspiciada por el
          Departamento de Educación de Puerto Rico. El Departamento de Educación
          de Puerto Rico no se solidariza necesariamente con los resultados de
          la investigación.”
        </p>
        <p>
          6- Las hojas de consentimiento informado contiene en cada una de sus
          páginas el sello oficial de SATPRe. El investigador se compromete a
          reproducirlas sin alterarlas para administrarla a los participantes de
          su estudio.
        </p>
        <p>
          7- Ninguna persona puede visitar las dependencias del DEPR para llevar
          a cabo las actividades de una investigación o sus fases relacionadas
          hasta tanto se le haya expedido una autorización firmada por el
          secretario auxiliar de SATPRe o por el superintendente regional a
          cargo del ORE.
        </p>
        <p>
          8- No se autorizará la salida de estudiantes de la escuela para
          participar en actividades de investigación o de sus fases
          relacionadas: la validación de instrumentos o prueba piloto, ni para
          participar en grupos focales.
        </p>
        <p>
          9- Durante el inicio y final del semestre académico, periodos de
          informes y pruebas sistémicas, no se autorizarán visitas a las
          escuelas con el propósito de desarrollar cualquier aspecto de la
          investigación o de sus fases relacionadas: la validación de
          instrumentos o prueba piloto. Las actividades del estudio no deberán
          afectar el período lectivo, ni las evaluaciones académicas de los
          estudiantes.
        </p>
        <p>
          10- Si el investigador es empleado del Departamento de Educación, pero
          no es maestro de la sala de clases, el tiempo que utilice en horas
          laborables para realizar asuntos relacionados al desarrollo de la
          investigación o sus fases, se descontará de su balance de vacaciones,
          ya que realiza esta gestión en su carácter personal. Si es maestro,
          deberá coordinar con su director escolar cómo llevará a cabo la
          investigación de forma que no se afecte el tiempo lectivo de los
          estudiantes.
        </p>
        <p>
          11- Todo cambio que realice el investigador, posterior a la expedición
          de la autorización para realizar el estudio, deberá someterlo por
          escrito a la oficina que le otorgó la autorización para la evaluación
          correspondiente, ya sea en la División de Investigaciones Pedagógicas
          de SATPRe o en la oficina del Superintendente Regional (ORE).
        </p>
        <p>
          12- Se le notifica al investigador que una vez finalice el estudio o
          sus fases, será responsable de subir una copia del trabajo final en
          formato digital (.pdf) en esta plataforma identificada como CIIE
          (Centro de Investigaciones e Innovaciones Educativas) en la página del
          DEPR. De no cumplir con esta disposición, el investigador se expone a
          que el DEPR no le autorice futuras investigaciones hasta cumplir con
          este requisito.
        </p>
        <p>
          13- Con el propósito enriquecer los procesos educativos y de aportar a
          otras investigaciones o estudios futuros, la Secretaría de
          Transformación, Planificación y Rendimiento (SATPRe) ha diseñado una
          Biblioteca Centro de Investigaciones para recopilar las
          investigaciones autorizadas por el DEPR. Todo trabajo que sea
          entregado como parte de una investigación en el DEPR será publicado en
          la Biblioteca Centro de Investigaciones.
        </p>
        <p>
          14- El Departamento de Educación no discrimina de ninguna manera por
          razón de edad, raza, color, sexo, nacimiento, condición de veterano,
          ideología política o religiosa, origen o condición social, orientación
          sexual o identidad de género, discapacidad o impedimento físico o
          mental; ni por ser víctima de violencia doméstica, agresión sexual o
          acecho.
        </p>
        <div ref="scrollToMe"></div>
      </div>
      <div
        v-if="this.userSelectedLang === this.lang.EN"
        class="text-container px-4"
      >
        <p>
          1 - The applicant releases the Department of Education of Puerto Rico
          from any responsibility for any claims that may arise as a result of
          the study's activities and the information requested and provided
          through this. The Department of Education of Puerto Rico is not liable
          for any damages or claims resulting from the conduct of the study or
          the research outcome. Thus, the Department of Education of Puerto
          Rico, its employees, and officials are relieved of any obligation and
          responsibility in any claims, lawsuits, or demands related, directly
          or indirectly, to this research. The research is independent and not
          sponsored by the Department of Education of Puerto Rico. The
          Department of Education of Puerto Rico does not necessarily endorse
          the research results.
        </p>
        <p>
          2 - The authorization request must be submitted with the required
          documents six (6) weeks prior to the start date of the research or any
          of its related phases: instrument validation or pilot test.
        </p>
        <p>
          3 - The validity period of the authorization granted for validation or
          pilot testing is six (6) months, and for the research (final phase),
          it is twelve (12) months from the date of issuance of the
          authorization memorandum.
        </p>
        <p>
          4 - If the researcher needs additional time to complete the study
          activities, they must submit a written request for a time extension to
          the office that issued the authorization: the Division of Pedagogical
          Research (SATPRe) or the corresponding Regional Superintendent's
          office in the ORE) before the validity of the granted authorization
          expires.
        </p>
        <p>
          5 - All submitted documents must include the following Department of
          Education of Puerto Rico disclaimer clause: "The Department of
          Education of Puerto Rico is released from any responsibility for any
          claims that may arise as a result of the study's activities and the
          information requested and provided through this. The Department of
          Education of Puerto Rico is not liable for any damages or claims
          resulting from the conduct of the study or the research outcome. Thus,
          the Department of Education of Puerto Rico, its employees, and
          officials are relieved of any obligation and responsibility in any
          claims, lawsuits, or demands related, directly or indirectly, to this
          research. The research is independent and not sponsored by the
          Department of Education of Puerto Rico. The Department of Education of
          Puerto Rico does not necessarily endorse the research results."
        </p>
        <p>
          6 - The informed consent forms contain the official SATPRe seal on
          each page. The researcher agrees to reproduce them without alterations
          to administer them to the participants of their study.
        </p>
        <p>
          7 - No person can visit DEPR premises to carry out research activities
          or its related phases until they have been issued an authorization
          signed by the Assistant Secretary of SATPRe or the Regional
          Superintendent in charge of the ORE.
        </p>
        <p>
          8 - Students are not authorized to leave school to participate in
          research activities or its related phases, including instrument
          validation or pilot testing, or to participate in focus groups.
        </p>
        <p>
          9 - During the start and end of the academic semester, reporting
          periods, and systemic testing periods, visits to schools for the
          purpose of developing any aspect of the research or its related
          phases, including instrument validation or pilot testing, will not be
          authorized. The study activities should not affect the instructional
          period or the academic evaluations of students.
        </p>
        <p>
          10 - If the researcher is an employee of the Department of Education
          but not a classroom teacher, the time spent during working hours for
          research-related matters will be deducted from their vacation balance,
          as this is considered personal business. If they are a teacher, they
          must coordinate with their school principal on how to conduct the
          research in a way that does not interfere with students' instructional
          time.
        </p>
        <p>
          11 - Any changes made by the researcher after the authorization for
          the study has been issued must be submitted in writing to the office
          that granted the authorization for the corresponding evaluation,
          either to the Division of Pedagogical Research at SATPRe or to the
          Regional Superintendent's office (ORE).
        </p>
        <p>
          12 - The researcher is notified that upon completion of the study or
          its phases, they are responsible for uploading a copy of the final
          work in digital format (.pdf) on this platform identified as CIIE
          (Center for Educational Research and Innovation) on the DEPR website.
          Failure to comply with this requirement may result in the DEPR not
          authorizing future research until it is fulfilled.
        </p>
        <p>
          13 - With the aim of enriching educational processes and contributing
          to other future research or studies, the Secretary of Transformation,
          Planning, and Performance (SATPRe) has designed a Research Center
          Library to compile research authorized by the DEPR. Any work submitted
          as part of research at the DEPR will be published in the Research
          Center Library.
        </p>
        <p>
          14 - The Department of Education does not discriminate in any way
          based on age, race, color, sex, birth, veteran status, political or
          religious ideology, origin or social status, sexual orientation or
          gender identity, disability or physical or mental impairment, or being
          a victim of domestic violence, sexual assault, or stalking.
        </p>
        <div ref="scrollToMe"></div>
      </div>
      <div class="read-more" @click="scrollToElement">
        <span>{{ $t('ReadMore') }}</span>
        <em class="fa fa-chevron-down" />
      </div>
    </div>
    <template #footer>
      <div class="d-flex align-items-center justify-content-center pb-3">
        <action-button
          class="btn-success px-4 py-2"
          :text="$t('ACCEPT')"
          i="far fa-check-circle"
          @click="$emit('accept')"
        />
      </div>
    </template>
  </custom-modal>
</template>

<script>
//libs
import ActionButton from 'ActionButton';
import lang from '@/utils/constants/lang';

//common components
import { CustomModal } from '@/components/common';

export default {
  name: 'CreateRequestModalConfirm',
  components: {
    ActionButton,
    CustomModal,
  },
  methods: {
    showModal() {
      this.$refs.createRequestModalConfirmRef.showModal();
    },
    hideModal() {
      this.$refs.createRequestModalConfirmRef.hideModal();
    },
    scrollToElement() {
      const el = this.$refs.scrollToMe;
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
    },
  },
  computed: {
    lang() {
      return lang;
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/scss/components/action-button/index.scss';
@import '@/scss/bootstrap/_colors.scss';

.text-container {
  height: 363px;
  overflow: auto;
}

.read-more {
  color: map-get($colors, 'yellow-star-2');
  font-size: 16px;
  font-weight: 300;
  text-align: center;
  margin-top: 20px;
  user-select: none;
  span {
    letter-spacing: -0.35px;
    margin-right: 10px;
  }
}

/* width */
::-webkit-scrollbar {
  width: 5px;
  background: map-get($colors, 'yellow-light');
}

/* Track */
::-webkit-scrollbar-track {
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: map-get($colors, 'yellow-star-3');
  border-radius: 10px;
}

.custom-modal__extended ::v-deep {
  .body-content {
    background: map-get($colors, 'gray-21') !important;
  }
}
</style>
